import styles from './StepIndicator.module.css';

const StepIndicator = ({ steps, active }) => {
  return (
    <ol className={styles.steps}>
      {steps.map((label, index) => {
        const done = index < active;
        const state = done ? styles.done : index === active ? styles.active : '';
        return (
          <li key={label} className={`${styles.step} ${state}`} aria-current={index === active ? 'step' : undefined}>
            <span className={styles.dot}>
              {done ? (
                <svg viewBox='0 0 14 14' fill='none' aria-hidden='true'>
                  <path d='M2.5 7.5l3 3 6-7' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
                </svg>
              ) : (
                index + 1
              )}
            </span>
            <span className={styles.label}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default StepIndicator;
